import { useState } from "react";
import { toast } from "sonner";
import { Wrench, Copy, ChevronDown } from "lucide-react";

export const CopyBox = ({ code, label }) => {
  const copy = () => { navigator.clipboard?.writeText(code); toast.success("Copied to clipboard"); };
  return (
    <div className="mt-2" data-testid="fix-copybox">
      {label && <div className="text-[10px] uppercase tracking-wider text-zinc-500 mb-1">{label}</div>}
      <div className="relative">
        <pre className="bg-black/60 border border-white/10 rounded-lg p-3 pr-10 text-[11px] text-[#8fe3ff] font-mono overflow-x-auto whitespace-pre-wrap break-all">{code}</pre>
        <button onClick={copy} data-testid="fix-copy-btn" className="absolute top-2 right-2 text-zinc-400 hover:text-white transition-colors" title="Copy">
          <Copy size={14} />
        </button>
      </div>
    </div>
  );
};

// Expandable "How to fix" block for a finding.
export default function FixGuide({ guide, testId }) {
  const [open, setOpen] = useState(false);
  if (!guide) return null;
  return (
    <div className="mt-2" data-testid={testId || "fix-guide"}>
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="fix-guide-toggle"
        className="inline-flex items-center gap-1.5 text-[11px] font-medium text-[#4da3ff] hover:text-white transition-colors"
      >
        <Wrench size={12} /> How to fix
        <ChevronDown size={12} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mt-2 rounded-lg border border-white/10 bg-black/20 p-3">
          {guide.steps?.length > 0 && (
            <ol className="list-decimal list-inside space-y-1 text-xs text-zinc-300">
              {guide.steps.map((s, i) => <li key={i} className="leading-relaxed">{s}</li>)}
            </ol>
          )}
          {guide.code && <CopyBox code={guide.code} label={guide.codeLabel} />}
        </div>
      )}
    </div>
  );
}
